module.exports = __webpack_public_path__ + "ab.no2.5b6979b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/ab.no2.jpg
// module id = 6lKS
// module chunks = 0